import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('form')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`
export const HideContainer = styled('div')`
  display: none;
`

export const MailLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-weight: 300;
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  margin: 0;

  &:hover {
    text-decoration: underline;
  }
`
